// import hooks
import { useTranslation } from "react-i18next";

// import components
import { Row, Col, Container } from "react-bootstrap";

// import assets
import fast from "../../assets/svg-icons/fast.svg";
import verified from "../../assets/svg-icons/verified.svg";
import payment from "../../assets/svg-icons/payment.svg";

const PastProductsList = ({ className }) => {
    const [t] = useTranslation("global");

    return (
        <div className={`post-products-div-container ${className}`}>
            <Container>
                <Row>
                    <Col md={3}>
                        <div className="past-products-img-container">
                            <img src={verified} alt="verified products icon" />
                        </div>
                        <div className="past-products-div">
                            <h3 className="post-products-h">
                                {t("main.verified-products")}
                            </h3>
                            <p>{t("main.verified-products-p")}</p>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="past-products-img-container">
                            <img src={payment} alt="payments icon" />
                        </div>
                        <div className="past-products-div">
                            <h3 className="post-products-h">
                                {t("main.pay-methods")}
                            </h3>
                            <p>{t("main.pay-methods-p")}</p>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="past-products-img-container">
                            <img src={fast} alt="navigation icon" />
                        </div>
                        <div className="past-products-div">
                            <h3 className="post-products-h">
                                {t("main.navigation")}
                            </h3>
                            <p>{t("main.navigation-p")}</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default PastProductsList;
